import Pdf from '@static/images/icons/pdf.svg';
import { Icon, typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

import { UploadingStatus } from '~/views/alfred/research/useUserUpload/use-user-upload.types';

export const PdfIcon = styled(Pdf)`
  height: 32px;
  width: 32px;
`;

export const SingleFileRoot = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
`;

export const PreviewWrapper = styled.div`
  position: relative;
`;

export const IconWrapper = styled.div`
  width: 100%;
`;

export const GreyOverlay = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(1, 1, 1, 0.5);
`;

export const SpinnerWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 50%);
`;

export const FileInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 70%;
`;

export const StyledImage = styled.img<{
  $status: UploadingStatus;
  $isPdf: boolean;
}>`
  width: 32px;
  height: 32px;
  ${({ $status, $isPdf }) =>
    $status !== 'complete' &&
    $isPdf &&
    css`
      opacity: 0.5;
    `}
`;

export const FileName = styled.span<{ $status: UploadingStatus }>`
  ${typographyV2.bodySm};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ $status }) => {
    switch ($status) {
      case 'uploading':
        return 'var(--text-soft)';
      case 'complete':
        return 'var(--text-default)';
      case 'error':
        return 'var(--text-disabled)';
      default:
        return 'var(--text-default)';
    }
  }};
`;

export const FileSize = styled.span<{ $status: UploadingStatus }>`
  ${typographyV2.bodySm};
  color: ${({ $status }) => {
    switch ($status) {
      case 'uploading':
        return 'var(--text-soft)';
      case 'complete':
        return 'var(--text-default)';
      case 'error':
        return 'var(--text-critical)';
      default:
        return 'var(--text-default)';
    }
  }};
`;

export const ErrorMessage = styled.span`
  ${typographyV2.bodySm};
  color: var(--text-critical);
`;

export const StyledIcon = styled(Icon)`
  cursor: pointer;
`;

export const StyledErrorIcon = styled(Icon)`
  position: absolute;
  top: 0;
  right: 0;
`;
